import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type TipoServicio = 'CAM' | 'CAP' | 'TAR' | 'TAE' | 'DEV' | 'NTC';

export interface DesgloseTipoServicioDia {
  tipo: TipoServicio;
  label: string;
  totalOrdenes: number;
  poligonosAbiertos: number;
  poligonosCerrados: number;
}

export interface DesgloseTipoPorPoligono {
  tipo: TipoServicio;
  label: string;
  cantidadOrdenes: number;
  cubicaje: number;
  estado: 'ABIERTO' | 'CERRADO';
}

export interface PoligonoServicioDia {
  id: number;
  codigo: string | null;
  nombre: string | null;
  totalServicios: number;
  desglose: DesgloseTipoPorPoligono[];
}

export interface GestionarServiciosDiaData {
  codigoBodega: string;
  fechaPicking: string;
  totalServicios: number;
  elegiblesCierre: number;
  elegiblesApertura: number;
  desglosePorTipo?: DesgloseTipoServicioDia[];
  detallePorPoligono?: PoligonoServicioDia[];
}

export interface GestionarServiciosDiaResultado {
  accion: 'CERRAR' | 'ABRIR';
  tipoServicio?: TipoServicio;
}

@Component({
  selector: 'app-modal-gestionar-servicios-dia',
  templateUrl: './modal-gestionar-servicios-dia.component.html',
  styleUrls: ['./modal-gestionar-servicios-dia.component.scss']
})
export class ModalGestionarServiciosDiaComponent {
  mostrarDetallePoligonos = false;

  constructor(
    public dialogRef: MatDialogRef<ModalGestionarServiciosDiaComponent, GestionarServiciosDiaResultado | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: GestionarServiciosDiaData
  ) { }

  toggleDetallePoligonos(): void {
    this.mostrarDetallePoligonos = !this.mostrarDetallePoligonos;
  }

  cerrarTodos(): void {
    this.dialogRef.close({ accion: 'CERRAR' });
  }

  abrirTodos(): void {
    this.dialogRef.close({ accion: 'ABRIR' });
  }

  cerrarTipo(tipoServicio: TipoServicio): void {
    this.dialogRef.close({ accion: 'CERRAR', tipoServicio });
  }

  abrirTipo(tipoServicio: TipoServicio): void {
    this.dialogRef.close({ accion: 'ABRIR', tipoServicio });
  }

  cancelar(): void {
    this.dialogRef.close(undefined);
  }
}
